<app-material [isLoading]="loading">
    <div class="header" header>
        <app-tabs *ngIf="!loading"
                  [tabs]="tabs"
                  [material]="false">
        </app-tabs>
    </div>
    <div class="body"
         body>
        <router-outlet *ngIf="!loading"></router-outlet>
    </div>
</app-material>

